<template>
  <div class="vx-row">
    <vx-card>
      <vs-row vs-w="12">
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
          <vs-button
            icon="keyboard_backspace"
            @click="goBack"
            >Back</vs-button
          >
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="10"
          vs-sm="4"
          vs-xs="12"
        >
          <h3>View Submitted Hours</h3>
        </vs-col>
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
  <download-excel
              :data="user_submitted_hours"
              :export-fields="json_fields"
              type="xls"
              name="submit_hours.xls"
            >
              <vs-button icon="file_download" color="primary" type="filled"> Export</vs-button
          >
            </download-excel>

          
          <!-- <vs-button
            icon="add"
            @click="addSubmitHours"
            color="danger"
            type="border"
            >Add</vs-button
          > -->
        </vs-col>
      </vs-row>
      <vs-divider class="m-5" />

      <vs-row vs-w="12" class="mb-10">
        <vs-col vs-type="flex" vs-lg="3" vs-sm="4" vs-xs="12">
          <span class="ml-4 p-2">Filter: </span>
          <v-select
            class="filter ml-2"
            :options="filterBySpecificDate"
            label="name"
            v-model="filterBySpecificDates"
          />
        </vs-col>

        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="6"
          vs-sm="4"
          vs-xs="12"
        >
          <div class="p-1" style="margin-left: 72px;">
            <span>Search Campaign: </span>
          </div>

          <CampaignAutocomplete
            :key="companySearchComponentKey"
            class="searchbox"
            :list="searchSubmittedHours"
            :searchOn="'submit_hours'"
            @event-name="handleChildEvent"
          ></CampaignAutocomplete>
          <vs-icon
            class="pl-5 pointer"
            icon="cancel"
            @click="resetCampaign"
            size="small"
          ></vs-icon>
        </vs-col>
        <vs-col vs-type="flex" vs-lg="3" vs-sm="4" vs-xs="12"> </vs-col>
        <vs-col vs-type="flex" vs-lg="3" vs-sm="4" vs-xs="12"> </vs-col>
      </vs-row>
      <vs-row vs-w="12" class="m-4">
        <vs-col vs-type="flex" vs-lg="2" vs-sm="4" vs-xs="12">
          <v-select v-if="showPagination" v-model="per_page" :options="size_per_page" />
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="8"
          vs-sm="4"
          vs-xs="12"
        >
          <span class=" p-2">Start: </span>
          <flat-pickr
            :config="configDatePicker"
            placeholder="Choose start time"
            name="start_time"
            v-model="filter.start_date"
          />

          <span class=" p-2">End: </span>
          <flat-pickr
            :config="configDatePicker"
            placeholder="Choose end time"
            name="end_time"
            v-model="filter.end_date"
          />
          <vs-button class="ml-5" @click="filterStartEndDate" color="primary"
            >Submit</vs-button
          >
          <!-- <vs-pagination :total="Math.ceil(total/per_page)" v-model="currentx"></vs-pagination> -->
        </vs-col>
        <vs-col vs-type="flex" vs-lg="2" vs-sm="4" vs-xs="12">
          <vs-button icon="refresh" @click="resetAll" color="primary"
            >Reset</vs-button
          >
             
        </vs-col>
      </vs-row>

      <vs-table
        class="mb-10"
        @search="handleSearch"
        @sort="handleSort"
        v-model="selected"
        stripe
        :data="user_submitted_hours"
      >
        <template slot="thead">
          <!-- <vs-th sort-key="s_no">S No.</vs-th> -->
          <vs-th sort-key="campaign_name">Campaign Name</vs-th>
          <vs-th sort-key="campaign_code">Campaign Code</vs-th>
          <vs-th sort-key="date">Date</vs-th>
          <vs-th sort-key="hours">Hours</vs-th>
          <vs-th sort-key="actions">Actions</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <!-- <vs-td :data="data[indextr]">
              {{ indextr + 1 }}
            </vs-td> -->
            <vs-td :data="data[indextr].campaign_name">
              {{ data[indextr].campaign_name }}
            </vs-td>
            <vs-td :data="data[indextr].campaign_code">
              {{ data[indextr].campaign_code }}
            </vs-td>
            <vs-td :data="data[indextr].date">
              {{ data[indextr].formatted_date }}
            </vs-td>
            <vs-td :data="data[indextr].hours">
              {{ data[indextr].hours }}
            </vs-td>
            <vs-td :data="data[indextr].actions">
              <vs-icon
                class="ml-10 removeButton"
                @click="viewSingleSubmitHour(data[indextr].uuid)"
                color="success"
                icon="visibility"
              ></vs-icon>
            </vs-td>
          </vs-tr>

          <vs-tr>
            <vs-td> </vs-td><vs-td> </vs-td>
            <vs-td> </vs-td>
            <vs-td> Total : {{ total_filtered_hours }} </vs-td>
            <vs-td> </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <template>
        <vs-pagination v-if="showPagination"
          :total="Math.ceil(total / per_page)"
          v-model="currentx"
        ></vs-pagination>
      </template>
    </vx-card>
  </div>
</template>

<script>
import defineAbilitiesFor from "@/config/abilities";
import moduleCampaignManagement from "@/store/campaign-management/moduleCampaignManagement.js";
import CampaignAutocomplete from "@/components/autocomplete/CampaignAutocomplete.vue";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import vSelect from "vue-select";
import moment from "moment";
import JsonExcel from "vue-json-excel";
export default {
  data: () => ({
    showPagination : true,
    authorized:true,
    total_filtered_hours: 0,
    selected_campaign_id: null,
    filterBySpecificDates: { name: "All", value: 0 },
    configDatePicker: {
      enableTime: false,
      enableSeconds: false
    },
    json_fields: {
      "Campaign Name": "campaign_name",
      "Campaign Code": "campaign_code",
      "Date": "date",
      "Hour": "hours",
      "Comments": "comments",
    },
    filter: {
      start_date: null,
      end_date: null
    },
    user_id: null,
    user_role: null,
    abilities: null,
    companySearchComponentKey: 0,
    selected: [],
    user_submitted_hours: [],
    currentx: 1,
    total: 0,
    size_per_page: [10, 20, 50, 100, 500],
    per_page: 10,
    paginationAttr: {
      page_no: 1,
      per_page: 10
    },
    filterBySpecificDate: [
      { name: "All", value: 0 },
      { name: "This Week", value: 7 },
      { name: "This Month", value: 30 },
      { name: "This Quarter", value: 90 },
      { name: "This Year", value: 365 }
    ]
  }),
  components: {
    CampaignAutocomplete,
    "v-select": vSelect,
    moduleCampaignManagement,
    flatPickr,
        downloadExcel: JsonExcel,

  },
  watch: {
    // total_filtered_hours: function(val) {
    //   if (val != 0) {
    //     // Now here are the minutes that the float currently shows
    //     let minutes = (val % 1) * 100;

    //     // And the hours
    //     let hours = Math.floor(val);

    //     // Here are the number of hours that can be reduced from minutes
    //     let AddHours = Math.floor(minutes / 60);

    //     // Adding them to the hours count
    //     hours += AddHours;

    //     // Reducing mintues
    //     minutes %= 60;

    //     // Finally formatting hour and minutes into your format
    //     let final = hours + minutes / 100.0;
    //             this.total_filtered_hours = final.toFixed(2);

    //   }
    // },
    currentx: function(val) {
      this.paginationSetPageSize();
    },
    per_page: function(val) {
      this.paginationSetPageSize();
    },
    filterBySpecificDates: function(val) {
      if (val.value != 0) {
        this.user_submitted_hours = [];
        this.filter.end_date = moment().format("YYYY-MM-DD");
        this.filter.start_date = moment()
          .subtract(val.value, "d")
          .format("YYYY-MM-DD");
        this.filterStartEndDate();
      } else {
        this.resetAll();
      }
    }
  },
  methods: {
    addTimes (startTime, endTime) {
  var times = [ 0, 0, 0 ]
  var max = times.length

  var a = (startTime || '').split(':')
  var b = (endTime || '').split(':')

  // normalize time values
  for (var i = 0; i < max; i++) {
    a[i] = isNaN(parseInt(a[i])) ? 0 : parseInt(a[i])
    b[i] = isNaN(parseInt(b[i])) ? 0 : parseInt(b[i])
  }

  // store time values
  for (var i = 0; i < max; i++) {
    times[i] = a[i] + b[i]
  }

  var hours = times[0]
  var minutes = times[1]
  var seconds = times[2]

  if (seconds >= 60) {
    var m = (seconds / 60) << 0
    minutes += m
    seconds -= 60 * m
  }

  if (minutes >= 60) {
    var h = (minutes / 60) << 0
    hours += h
    minutes -= 60 * h
  }

  return ('0' + hours).slice(-2) + ':' + ('0' + minutes).slice(-2)
},
    resetAll() {
      this.resetCampaign();
      this.filter.start_date = null;
      this.filter.end_date = null;
    },
    resetCampaign() {
      moduleCampaignManagement.state.selected_submit_hours = [];
      this.selected_campaign_id = null;
      this.fetchSubmitHours();
      this.companySearchComponentKey += 1;
      this.showPagination = true
    },
    paginationSetPageSize() {
      this.paginationAttr = {
        page_no: this.currentx,
        per_page: this.per_page
      };
      this.fetchSubmitHours();
    },
    fetchCampaignWithFilter() {
      let filter = {};
      filter.status = this.selected_campaign_status;
      filter.client_id = this.selected_client_id;
      filter.user_role = this.user_role;
      filter.user_id = this.user_id;
      this.$store
        .dispatch("campaignsManagement/fetchAllCampaignsWithFilter", filter)
        .then(res => {
          this.campaigns = res.data;
          let self = this;
          self.campaigns = self.campaigns.filter(function(ele) {
            if (ele.campaign_status) {
              self.showStatusName(ele.campaign_status).then(function(data) {
                if (data) {
                  ele.campaign_status = data.data.campaign_status;
                }
              });
            } else {
              ele.campaign_status = null;
            }

            if (ele.client_id) {
              //get promise value
              self.showClientName(ele.client_id).then(function(data) {
                if (data) {
                  ele.client_id = data.data.company_name;
                }
              });
            } else {
              ele.client_id = null;
            }
            return ele;
          });
        })
        .catch(err => {
                       if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    filterStartEndDate() {
      let filter = {};
      if (moduleCampaignManagement.state.selected_submit_hours.length != 0) {
        let selected = JSON.parse(
          moduleCampaignManagement.state.selected_submit_hours
        );
        this.selected_campaign_id = selected[0].campaign_id;
        filter.campaign_id = this.selected_campaign_id;
      } else {
        filter.campaign_id = null;
      }

      filter.user_role = this.user_role;
      filter.user_id = this.user_id;
      filter.start_date = this.filter.start_date;
      filter.end_date = this.filter.end_date;
      return this.$store
        .dispatch("campaignsManagement/filterStartEndDate", filter)
        .then(response => {
          if (response) {
            let self = this;
            let results = JSON.parse(response.data);
            if (results.length != 0) {
              self.user_submitted_hours = results;
              self.total_filtered_hours = '0:00';
              self.user_submitted_hours.map(ele => {
                ele.formatted_date = moment(ele.date).format("DD/MM/YYYY");
                ele.uuid = ele.submit_hour_id;

                ele.hours = ele.hours.replace(".", ":");
                self.total_filtered_hours = self.addNewTimes(self.total_filtered_hours, ele.hours);

                // self.total_filtered_hours += parseFloat(ele.hours);
              });
              // self.total_filtered_hours = self.total_filtered_hours.toFixed(2);
            }else{
               self.user_submitted_hours = [];
              self.total_filtered_hours = 0;
              //  self.total_filtered_hours = self.total_filtered_hours.toFixed(2);
            }
          }
        })
        .catch(err => {
             if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    searchSubmittedHours(inputValue) {
      let filter = {};
      filter.search_term = inputValue;
      filter.user_role = this.user_role;
      filter.user_id = this.user_id;
      return this.$store
        .dispatch("campaignsManagement/searchSubmittedHours", filter)
        .then(response => {
          if (response) {
            let data = moduleCampaignManagement.state.submitted_hours;
            if (data) {
              let mappedArray = [];
              for (const property in data) {
                if (typeof data[property].campaign_name != "undefined") {
                  mappedArray.push({
                    id: data[property].id,
                    name:
                      data[property].campaign_name +
                      "  -   " +
                      data[property].campaign_code,
                    type: "campaign"
                  });
                }
              }
              return mappedArray;
            }
          }
        })
        .catch(err => {
             if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    goBack: function() {
      this.$router.go(-1);
    },
    viewSingleSubmitHour(id) {
      this.$router.push({ path: "/campaign/viewSubmitHour/" + id });
    },
    addSubmitHours() {
      this.$router.push({ path: "/campaigns/submitHours" });
    },
    handleSearch(searching) {
      // console.log(`The user searched for: ${searching}`);
    },
    handleSort(key, active) {
      // console.log(`the user ordered: ${key} ${active}`);
    },
    addNewTimes(start_date, end_date) {





var time1 = start_date;
var time2 = end_date;





var hour=0;
var minute=0;


var splitTime1= time1.split(':');
var splitTime2= time2.split(':');

var allTimes = [splitTime1, splitTime2]

allTimes.forEach(element => {
  
    hour += parseInt(element[0])
    minute += parseInt(element[1])
})

hour += Math.floor(minute / 60);


minute = minute % 60



return hour+ ":" + minute






},
    handleChildEvent() {
      let self = this;
      let results = JSON.parse(
        moduleCampaignManagement.state.selected_submit_hours
      );
      self.total_filtered_hours = '0:00';
      if (results.length != 0) {
        self.user_submitted_hours = results;
        self.user_submitted_hours.map(ele => {
          ele.formatted_date = moment(ele.date).format("DD/MM/YYYY");


          ele.hours = ele.hours.replace(".", ":");
          self.total_filtered_hours = self.addNewTimes(self.total_filtered_hours, ele.hours);

          // self.total_filtered_hours = self.addTimes(self.total_filtered_hours, ele.hours);

          // self.total_filtered_hours += parseFloat(ele.hours);
        });
        // self.total_filtered_hours = self.total_filtered_hours.toFixed(2);
      }
      this.filter.start_date = null;
      this.filter.end_date = null;
      this.showPagination = false
    },
    fetchSubmitHours() {
      let self = this;
      this.paginationAttr.user_id = this.user_id;
      this.$store
        .dispatch("campaignsManagement/fetchSubmitHours", this.paginationAttr)
        .then(res => {
          let self = this;
          let result = JSON.parse(res.data);
          // console.log(result);
          self.total_filtered_hours = '0:00';

          if (result.length != 0) {
            self.user_submitted_hours = result;
            self.user_submitted_hours.map(ele => {
              ele.formatted_date = moment(ele.date).format("DD/MM/YYYY");
              // self.total_filtered_hours += parseFloat(ele.hours);
              ele.hours = ele.hours.replace(".", ":");
              self.total_filtered_hours = self.addNewTimes(self.total_filtered_hours, ele.hours);
            });
            // self.total_filtered_hours = self.total_filtered_hours.toFixed(2);

            self.total = result[0].total;
            self.per_page = result[0].per_page;
            // self.total_filtered_hours = result[0].total_hours.toFixed(2);
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  mounted() {
    if(this.authorized){
      this.fetchSubmitHours();
    }
  },
  created() {
    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.user_id = userInfo["uid"];
    this.user_role = userInfo["userRole"];


    if (this.user_role == 'Client Administrator' || this.user_role == 'Client'){
      this.authorized = false
      this.$router.replace("/unauthorized")
    }


    var self = this;
    defineAbilitiesFor().then(function(data) {
      self.abilities = data;
    });
    if (!moduleCampaignManagement.isRegistered) {
      this.$store.registerModule(
        "campaignsManagement",
        moduleCampaignManagement
      );
      moduleCampaignManagement.isRegistered = true;
    }
  }
};
</script>
<style scoped>
.vs-table--tbody-table tr {
  -webkit-transition: none;
  transition: none;
  background: #fff;
}

.vs-table--tbody-table
  .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  -webkit-transform: none;
  transform: none;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .tr-values .vs-table--td {
  padding: 15px 15px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  padding: 25px 15px;
  font-weight: 600;
  font-size: 14px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  width: 325px !important;
}
.filter {
  width: 300px;
}
.searchbox {
  margin-left: 5px;
  width: 600px;
}

.pointer {
  cursor: pointer;
}

.item.expanded {
  background-color: white !important;
  color: black !important;
}

.tr-table-state-primary,
.vs-table-primary .is-selected {
  background: none !important;
  box-shadow: none !important;
}

.tr-table-state-primary,
.vs-table-primary .is-selected {
  color: #626262 !important;
  -webkit-box-shadow: 0 0 1px 0 rgba(var(--vs-primary), 1) !important;
  box-shadow: 0 0 1px 0 rgba(var(--vs-primary), 1) !important;
}

.address_th {
  padding: 30px;
}

.address_td {
  padding: 30px;
  font-weight: 500;
}
</style>

<style lang="stylus">
.con-expand-users
  .con-btns-user
    display flex
    padding 10px
    padding-bottom 0px
    align-items center
    justify-content space-between
    .con-userx
      display flex
      align-items center
      justify-content flex-start
  .list-icon
    i
      font-size .9rem !important
</style>
